'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _LanguageDropdown = require('./LanguageDropdown.scss');var styles = _interopRequireWildcard(_LanguageDropdown);
var _constants = require('../../constants');
var _changeLocale = require('../../helpers/changeLocale');var _changeLocale2 = _interopRequireDefault(_changeLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var LanguageDropdown = function (_Component) {_inherits(LanguageDropdown, _Component);function LanguageDropdown() {var _temp, _this, _ret;_classCallCheck(this, LanguageDropdown);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      collapsed: false }, _this.












    getRef = function (ref) {_this.dropdownList = ref;}, _this.

    handleClick = function (evt) {
      if (
      !_this.state.collapsed ||
      !_this.dropdownList ||
      evt.target.classList.contains(styles.titleContainer))
      {
        return undefined;
      }

      return _this.setState({ collapsed: false });
    }, _this.

    handleChangeLocale = function (locale) {return (0, _changeLocale2.default)(locale, _this.props.routeData);}, _temp), _possibleConstructorReturn(_this, _ret);}LanguageDropdown.prototype.componentWillMount = function componentWillMount() {if (global && global.window) {window.addEventListener('mouseup', this.handleClick);}};LanguageDropdown.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('mouseup', this.handleClick);};LanguageDropdown.prototype.

  render = function render() {var _this2 = this,_cx;var
    collapsed = this.state.collapsed;
    var caretStyle = 'caret-' + (collapsed ? 'up' : 'down');
    var locales = _constants.languages.filter(function (_ref) {var value = _ref.value;return value !== _this2.props.locale;});
    var currentLocale = _constants.languages.find(function (_ref2) {var value = _ref2.value;return value === _this2.props.locale;});

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.container, styles[this.props.className], (_cx = {}, _cx[
          styles.collapsed] = this.state.collapsed, _cx)) },


        _react2.default.createElement('div', {
            className: styles.titleContainer,
            onClick: function onClick() {return _this2.setState({ collapsed: !_this2.state.collapsed });} },

          currentLocale.flagIcon,
          _react2.default.createElement('div', { className: styles.caret + ' ' + styles[caretStyle] })),


        _react2.default.createElement('ul', { className: styles.list, ref: this.getRef },
          locales.map(function (locale) {
            var handleChange = function handleChange() {return _this2.handleChangeLocale(locale.value);};
            return (
              _react2.default.createElement('li', { key: locale.value, onClick: handleChange },
                locale.flagIcon));


          }))));



  };return LanguageDropdown;}(_react.Component);


LanguageDropdown.propTypes = {
  locale: _propTypes2.default.string,
  routeData: _propTypes2.default.object,
  className: _propTypes2.default.string };exports.default =


LanguageDropdown;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageDropdown/LanguageDropdown.js
// module id = 2702
// module chunks = 0